import api from './index'
import { axios } from '@/utils/request'

export function createConversation(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListConversation(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'list',
    method: 'GET',
    params: parameter
  })
}

export function getDetailConversation(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'detail',
    method: 'GET',
    params: parameter
  })
}

export function updateConversation(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteConversation(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'delete',
    method: 'POST',
    data: parameter
  })
}